module.exports = __webpack_public_path__ + "jm.svg?1b388cb263bd368e45888104001165b2";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/jm.svg
// module id = 1178
// module chunks = 0